import { Navigate, Route, useLocation } from "@solidjs/router";
import { type ParentProps, Show } from "solid-js";
import { useAuth } from "./auth/AuthContext.tsx";
import { LOGIN_PATH, loginRedirectState, START_PATH } from "./auth/guard.ts";
import { AppShell } from "./components/AppShell.tsx";
import { ApiKeys } from "./pages/ApiKeys.tsx";
import { ConfirmTotp } from "./pages/ConfirmTotp.tsx";
import { Login } from "./pages/Login.tsx";
import { Onboarding } from "./pages/Onboarding.tsx";
import { Register } from "./pages/Register.tsx";

/** Gate the protected routes behind a live session; otherwise redirect to /login. */
function ProtectedShell(props: ParentProps) {
  const { session } = useAuth();
  const location = useLocation();
  return (
    <Show
      when={session()}
      fallback={
        <Navigate
          href={LOGIN_PATH}
          state={loginRedirectState(`${location.pathname}${location.search}${location.hash}`)}
        />
      }
    >
      <AppShell>{props.children}</AppShell>
    </Show>
  );
}

const RedirectToStart = () => <Navigate href={START_PATH} />;

/**
 * GG-Coin developer portal (#31) — the agent-economy front door. Sign in, then a
 * one-page onboarding: issue a key and copy the quickstart. (Dev billing is
 * deferred until the payment gateway lands — see #150.)
 */
export function App() {
  return (
    <>
      <Route path="/login" component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/confirm-totp" component={ConfirmTotp} />
      <Route path="/" component={ProtectedShell}>
        <Route path="/" component={RedirectToStart} />
        <Route path="/start" component={Onboarding} />
        <Route path="/keys" component={ApiKeys} />
        <Route path="*" component={RedirectToStart} />
      </Route>
    </>
  );
}
